<template>
    <div class="default-topic-section-container" :class="{ 'dark-theme': dark }">
        <div class="default-topic-section-title-container">
            <div v-if="title && typeof title === 'string'" class="default-topic-section-title" v-html="$t(title)" />
            <div
                v-if="subTitle && $t(subTitle) !== '' && !subTitleTopicHide"
                class="default-topic-section-subtitle"
                v-html="$t(subTitle)"
            />
            <div v-if="describe && $t(describe) !== ''" class="default-topic-section-describe" v-html="$t(describe)" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import contentServicesImg from '@assets/imgs/Support/ContentServices/headimg.png';
    import contentServicesImgMobile from '@assets/imgs/Support/ContentServices/headimgMobile.png';

    import consulationServiceImg from '@assets/imgs/Support/ConsulationService/headimg.png';
    import consulationServiceImgMobile from '@assets/imgs/Support/ConsulationService/headimgMobile.png';

    import brandImg from '@assets/imgs/Solutions/Brand/Swipper/bg.jpg';
    import brandImgMobile from '@assets/imgs/Solutions/Brand/Swipper/bgmobile.png';

    import manufacturerImg from '@assets/imgs/Solutions/Manufacturer/Swipper/bg.jpg';
    import manufacturerImgMobile from '@assets/imgs/Solutions/Manufacturer/Swipper/bgmobile.png';

    import solutionsFabricImg from '@assets/imgs/Solutions/Fabric/Swipper/bg.jpeg';
    import solutionsFabricImgMobile from '@assets/imgs/Solutions/Fabric/Swipper/bgMobile.jpeg';

    import newsCenterImg from '@assets/imgs/ResourceCenter/News/headimg.jpeg';

    import educationImg from '@assets/imgs/Solutions/Education/topicImage.png';

    import customerSuccessImg from '@assets/imgs/Support/CustomerSuccess/headimg.jpg';
    import customerSuccessImgMobile from '@assets/imgs/Support/CustomerSuccess/headimgMobile.jpg';

    import partnersImg from '@assets/imgs/ResourceCenter/Partners/headimg.jpg';
    import partnersImgMobile from '@assets/imgs/ResourceCenter/Partners/headimgMobile.jpg';

    import fellowshipImg from '@assets/imgs/AboutUs/Fellowship/Swipper/bg.jpg';
    import fellowshipImgMobile from '@assets/imgs/AboutUs/Fellowship/Swipper/bgMobile.jpeg';

    import bgImage1 from '@assets/imgs/AboutUs/Introduction/Swipper/bg.jpg';

    import bgImageMobile1 from '@assets/imgs/AboutUs/Introduction/Swipper/bgMobile.jpg';
    import bgImage2 from '@assets/imgs/AboutUs/Responsibility/Swipper/bg.jpg';
    import bgImageMobile2 from '@assets/imgs/AboutUs/Responsibility/Swipper/bgMobile.jpg';
    // 示例

    type PageType =
        | 'Education' // 解决方案页
        | 'Brand'
        | 'Manufacturer'
        | 'Fabric'
        | 'ContentServices' // 服务支持页
        | 'CustomerSuccess'
        | 'ConsultationService' // 咨询服务
        | 'Partners' // 资源中心
        | 'Case'
        | 'News'
        | 'Introduction' // 关于我们
        | 'Responsibility'
        | 'Fellowship';

    const props = withDefaults(
        defineProps<{
            type: PageType;
            dark?: boolean;
        }>(),
        { dark: false },
    );

    const mapData = new Map<PageType, UnionTitle>([
        [
            'Education',
            {
                title: 'global_solutions_edu_topic_title',
                subTitle: 'global_solutions_edu_topic_subtitle',
                describe: 'global_home_header_submenu_link_1_3_des',
                bgImage: educationImg,
                bgImageMobile: educationImg,
            },
        ],
        [
            'Brand',
            {
                title: 'global_solutions_brand_swipper_title',
                subTitle: 'global_solutions_brand_swipper_subtitle',
                describe: 'global_home_header_submenu_link_1_0_des',
                bgImage: brandImg,
                bgImageMobile: brandImgMobile,
            },
        ],
        [
            'Manufacturer',
            {
                title: 'global_solutions_manufacturer_swipper_title',
                subTitle: 'global_solutions_manufacturer_swipper_subtitle',
                describe: 'global_home_header_submenu_link_1_1_des',
                bgImage: manufacturerImg,
                bgImageMobile: manufacturerImgMobile,
            },
        ],
        [
            'Fabric',
            {
                title: 'global_solutions_fabric_swipper_title',
                subTitle: 'global_solutions_fabric_swipper_subtitle',
                describe: 'global_home_header_submenu_link_1_2_des',
                bgImage: solutionsFabricImg,
                bgImageMobile: solutionsFabricImgMobile,
            },
        ],
        [
            'ContentServices',
            {
                title: 'global_support_contentservices_swipper_title',
                subTitle: 'global_support_contentservices_swipper_subtitle',
                bgImage: contentServicesImg,
                bgImageMobile: contentServicesImgMobile,
            },
        ],
        [
            'ConsultationService',
            {
                title: 'global_support_consultationservice_swipper_title',
                subTitle: 'global_support_consultationservice_swipper_subtitle',
                bgImage: consulationServiceImg,
                bgImageMobile: consulationServiceImgMobile,
            },
        ],
        [
            'CustomerSuccess',
            {
                title: 'global_support_customer_success_swipper_title',
                subTitle: 'global_support_customer_success_swipper_subtitle',
                // subTitleTopicHide: true,
                bgImage: customerSuccessImg,
                bgImageMobile: customerSuccessImgMobile,
            },
        ],
        [
            'Case',
            {
                title: 'global_resource_center_case_swipper_title',
                subTitle: 'global_resource_center_case_swipper_subtitle',
                describe: 'global_resource_center_case_swipper_describe',
                bgImage: customerSuccessImg,
                bgImageMobile: customerSuccessImgMobile,
            },
        ],
        [
            'News',
            {
                title: 'global_resource_center_news_swipper_title',
                subTitle: 'global_resource_center_news_swipper_subtitle',
                bgImage: newsCenterImg,
                bgImageMobile: newsCenterImg,
            },
        ],
        [
            'Partners',
            {
                title: 'global_resource_center_partners_swipper_title',
                subTitle: 'global_resource_center_partners_swipper_subtitle',
                describe: 'global_resource_center_partners_swipper_describe',
                bgImage: partnersImg,
                bgImageMobile: partnersImgMobile,
            },
        ],
        [
            'Fellowship',
            {
                title: 'global_aboutus_fellowship_swipper_title',
                subTitle: 'global_aboutus_fellowship_swipper_subtitle',
                // describe: 'global_aboutuss_manufacturer_swipper_describe',
                bgImage: fellowshipImg,
                bgImageMobile: fellowshipImgMobile,
            },
        ],
        [
            'Introduction',
            {
                title: 'global_aboutus_introduction_swipper_title',
                // subTitle: 'global_aboutus_introduction_swipper_subtitle',
                // describe: 'global_aboutuss_edu_topic_describe',
                bgImage: bgImage1,
                bgImageMobile: bgImageMobile1,
            },
        ],
        [
            'Responsibility',
            {
                title: 'global_aboutus_responsibility_swipper_title',
                subTitle: 'global_aboutus_responsibility_swipper_subtitle',
                // describe: 'global_aboutuss_brand_swipper_describe',
                bgImage: bgImage2,
                bgImageMobile: bgImageMobile2,
            },
        ],
    ]);

    const title = computed(() => mapData.get(props.type)?.title);
    const subTitle = computed(() => mapData.get(props.type)?.subTitle);
    const subTitleTopicHide = computed(() => mapData.get(props.type)?.subTitleTopicHide);
    const describe = computed(() => mapData.get(props.type)?.describe);
    const bgImage = computed(() => `url(${mapData.get(props.type)?.bgImage})`);
    const bgImageMobile = computed(() => `url(${mapData.get(props.type)?.bgImageMobile})`);

    console.log('subTitleTopicHide', subTitleTopicHide, mapData.get(props.type));
    // onMounted(() => {
    //     const ifMatched = matchMobile();
    //     const topicSection = document.querySelector('.default-topic-section-container') as HTMLElement;
    //     if (ifMatched) {
    //         topicSection.style.backgroundImage = `url(${bgImageMobile.value})`;
    //     }
    // });
</script>

<style lang="less" scoped>
    .default-topic-section-container {
        color: #fff;
        height: .convert(826px) [ @vh-nolimit];
        font-style: normal;
        position: relative;
        font-family: Montserrat, 'HarmonyOS Sans SC';
        background-size: cover;
        background-repeat: no-repeat;
        background-image: v-bind(bgImage);

        @media (max-width: @screen-mobile-width) {
            background-position: 65% 50%;
            height: 100vh;
            height: calc(var(--vh, 1vh) * 100);
            background-image: v-bind(bgImageMobile);
        }
        .default-topic-section-title-container {
            position: absolute;
            left: 50%;
            bottom: 40px;
            transform: translate(-50%, 0);
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 60vw;

            text-align: center;

            @media (max-width: @screen-mobile-width) {
                left: 5%;
                width: 90%; // 100% - 5% - 5%
                transform: none;
                align-items: flex-start;
                gap: 5px;
                bottom: .convert(52px) [ @vw-mobile];
                width: 90vw;

                text-align: left;
            }
            .default-topic-section-title {
                font-size: .convert(64px) [ @vw];
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                white-space: nowrap;
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(44px) [ @vw-mobile]; //44px
                    white-space: normal;
                }
            }
            .default-topic-section-subtitle {
                font-size: .convert(40px) [ @vw]; //40px
                font-weight: 400;
                line-height: normal;
                margin-top: 20px;
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(20px) [ @vw-mobile]; //20px
                    margin: 0;
                }
            }
            .default-topic-section-describe {
                // transform: translateY(@margin-line);
                font-size: .convert(@font-size-xl) [ @vw]; //40px
                margin-top: 20px;
                font-family: 'HarmonyOS Sans SC';
                white-space: nowrap;
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(12px) [ @vw-mobile]; //12px
                    margin: 0;
                    white-space: normal;
                    // transform: translateY(.convert(5px) [ @vw-mobile]);
                }
            }
        }

        &.dark-theme {
            color: #000;
        }
    }
</style>
